import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import ConfirmDialog from '../ConfirmDialog';
import Icon from '../Icon';
import template from './template.xlsx';
import XLSX from 'xlsx';
import validator from 'validator';
import groupBy from 'lodash/groupBy';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';

export default class FileInputReader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showConfirm: false,
			file: null,
			readyToUpload: false
		};

		this.uploadFile = this.uploadFile.bind(this);
		this.toggleShowConfirm = this.toggleShowConfirm.bind(this);
		this.confirmUpload = this.confirmUpload.bind(this);
		this.onClickUpload = this.onClickUpload.bind(this);
		this.removeFile = this.removeFile.bind(this);
	}

	toggleShowConfirm() {
		const showConfirm = !this.state.showConfirm;

		this.setState({
			showConfirm
		});
	}

	confirmUpload(event) {
		this.setState({
			file: event.target.files[0],
			showConfirm: true
		});
	}

	uploadFile() {
		const { file } = this.state;
		if (file) {
			const { loadCallback } = this.props;
			if (file) {
				let reader = new FileReader();
				reader.onload = function(e) {
					const rawData = new Uint8Array(e.target.result);
					const workbook = XLSX.read(rawData, { type: 'array' });
					let data = XLSX.utils.sheet_to_json(
						workbook.Sheets[workbook.SheetNames[0]],
						{ range: 7 }
					);
					function makePassword() {
						var text = '';
						var possible =
							'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

						for (var i = 0; i < 8; i++)
							text += possible.charAt(
								Math.floor(Math.random() * possible.length)
							);

						return text;
					}
					data = data.map(row => {
						if (!row.password) {
							return {
								...row,
								password: makePassword()
							};
						}
						return row;
					});
					let valid = true;
					let errors = [];
					data.forEach((row, i) => {
						const index = i + 2;
						if (!row.firstName) {
							valid = false;
							errors.push(`Error riga ${index}: 'firstName' empty!`);
						}
						if (!row.lastName) {
							valid = false;
							errors.push(`Error riga ${index}: 'lastName' empty!`);
						}
						if (!row.username) {
							valid = false;
							errors.push(`Error riga ${index}: 'username' not valid!`);
						}
						if (!(row.coordinator === 'true' || row.coordinator === 'false')) {
							valid = false;
							errors.push(
								`Error riga ${index}: 'coordinator' should be equal to 'true' or 'false'!`
							);
						}
						/* if (!row.name) {
							valid = false;
							errors.push(`Error riga ${index}: 'name' empty!`);
						} */
						if (!row.team) {
							valid = false;
							errors.push(`Error riga ${index}: 'team' empty!`);
						}
					});
					const groupedData = groupBy(data, 'team');
					forEach(groupedData, (list, key) => {
						const leaders = filter(list, ele => ele.coordinator === 'true');
						const numberOfLaders = leaders ? leaders.length : 0;
						if (numberOfLaders === 0) {
							valid = false;
							errors.push(`Coordinator not found for team '${key}'`);
						}
						if (numberOfLaders > 1) {
							valid = false;
							errors.push(
								`Too many coordinators found: ${numberOfLaders} coordinators for team '${key}'`
							);
						}
					});
					loadCallback(data, valid, errors);
				};

				reader.onerror = function() {
					throw new Error('Errore durante la lettura del file');
				};

				reader.readAsArrayBuffer(file);

				if (reader) {
					this.setState({
						readyToUpload: true
					});
				}
			} else {
				throw new Error('Impossibile recuperare il file');
			}
		} else {
			window.alert('Please select a file!');
		}
		this.removeFile();
		this.toggleShowConfirm();
	}

	onClickUpload(event) {
		event.preventDefault();
		this.uploadInput.click();
	}

	removeFile() {
		this.setState({
			file: null,
			readyToUpload: false
		});
		this.uploadInput.value = '';
		//console.log(this.uploadInput.files);
	}

	render() {
		const {
			showConfirm
			// file,
			// readyToUpload
		} = this.state;
		const { uploadCta } = this.props;

		return (
			<div className="FileInputReader">
				{showConfirm && (
					<ConfirmDialog
						id={this.props.id}
						title={'Confirm upload'}
						description={'Are you sure you want to upload this file?'}
						theme="green"
						acceptButton="Yes, confirm"
						show={showConfirm}
						height={200}
						confirmClicked={this.uploadFile}
						closeDialogClicked={() => {
							this.removeFile();
							this.toggleShowConfirm();
						}}
					/>
				)}
				<input
					className="FileInputReader-input"
					ref={input => (this.uploadInput = input)}
					type="file"
					id={this.props.id}
					onChange={this.confirmUpload}
					accept=".xlsx"
				/>
				<div className="FileInputReader-content">
					<button
						className="FileInputReader-button"
						onClick={this.onClickUpload}
					>
						<div className="FileInputReader-icon">
							<Icon icon={'upload'} />
						</div>
						<span className="FileInputReader-link">{uploadCta}</span>
					</button>
					{/*!readyToUpload ? (
						<button
							className="FileInputReader-button"
							onClick={this.onClickUpload}
						>
							<div className="FileInputReader-icon">
								<Icon icon={'upload'} />
							</div>
							<span className="FileInputReader-link">{uploadCta}</span>
						</button>
					) : (
						<div className="FileInputReader-file">
							<span className="FileInputReader-filename">{file.name}</span>
							<button
								className="FileInputReader-remove"
								onClick={this.removeFile}
							>
								<Icon icon={'trash'} />
							</button>
						</div>
					)*/}
					<div className="FileInputReader-description">
						Use this upload box to create a new sessions or to add new games to
						an existing one.
					</div>
					<a
						className="FileInputReader-template"
						href={template}
						download={'template.xlsx'}
					>
						Click Here to download an input template.
					</a>
				</div>
			</div>
		);
	}
}

FileInputReader.propTypes = {
	name: PropTypes.string,
	loadCallback: PropTypes.func.isRequired,
	uploadCta: PropTypes.string
};
